module.exports = __webpack_public_path__ + "static/img/pipedrive.cb5a247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pipedrive.png
// module id = nvvg
// module chunks = 1